/**
 * Sanitize values to prevent PII data
 * @param {string} value String to sanitize
 * @return {object} Sanitized input
 */
export default function sanitize(value) {
  const blacklist = new RegExp(/[0-9@]/ig);
  return blacklist.test(value) ? "sanitized" : value;
}
